import { useCommerceComponents } from 'src/theme';
import type { ThemeConfig } from 'src/theme/provider/commerce-components/context';

/**
 * Reads the theme-declared, non-component config (`customTagFilters`, ...) off the resolved
 * remote theme module.
 */
export function useRemoteThemeConfig(): ThemeConfig {
  const { themeConfig } = useCommerceComponents();
  return themeConfig;
}
